import { render, staticRenderFns } from "./ModalSteps.vue?vue&type=template&id=30c9477b&scoped=true&"
import script from "./ModalSteps.vue?vue&type=script&lang=ts&"
export * from "./ModalSteps.vue?vue&type=script&lang=ts&"
import style0 from "./ModalSteps.vue?vue&type=style&index=0&id=30c9477b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c9477b",
  null
  
)

export default component.exports